<script lang="ts">
	import { get } from 'svelte/store';
	//Formatting
	import { format } from 'svelte-i18n';
	//Design system components
	import { Input, Radio, Toggle } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar, getErrorOrInfoMessageForMinAndMaxUnit } from 'src/helpers/utilities';
	import { getNumberInputConfig } from 'src/helpers/number_input_helpers';
	import {
		CAMERA_DURATION_MAX,
		CAMERA_DURATION_MIN,
	} from 'src/helpers/actions/local/devices/camera_local_actions';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

	export let controlOption: LocalControlOptions;

	const CAMERA_DURATION_UNIT = get(format)('select_units_seconds', {
		default: 'seconds',
	});

	$: minMaxInfo = getErrorOrInfoMessageForMinAndMaxUnit(
		controlOption.params.duration,
		CAMERA_DURATION_MIN,
		CAMERA_DURATION_MAX,
		CAMERA_DURATION_UNIT,
	);
</script>

{#if controlOption.attr?.duration != undefined}
	<div class="d-flex flex-direction-column">
		<Toggle
			id="toggle-camera-duration"
			class="mb-s"
			size="m"
			bind:checked={controlOption.attr.duration}
		>
			{$format('local_action_camera_set_duration', {
				default: 'Set Duration property',
			})}
		</Toggle>
		<Input
			size="m"
			value={String(controlOption.params.duration ?? 0)}
			label={$format('local_action_camera_duration_placeholder', {
				default: 'e.g. 30 (in seconds)',
			})}
			{...getNumberInputConfig()}
			icon="fa fa-timer"
			tabIndex="-1"
			disabled={!controlOption.attr.duration}
			on:input={(e) => {
				controlOption.params.duration = e.target['value'].trim();
			}}
			info={minMaxInfo.info}
			error={minMaxInfo.error}
			id="input-camera-duration"
			aria-labelledby="input-camera-duration"
		/>
	</div>
{:else if controlOption.attr?.config != undefined}
	{#if controlOption.attr.config.arm != undefined}
		<div class="d-flex flex-direction-column">
			<Toggle
				id="toggle-camera-arm"
				class="mb-s"
				size="m"
				bind:checked={controlOption.attr.config.arm}
			>
				{$format('local_action_camera_motion_detection', {
					default: 'Set Motion Detection property',
				})}
			</Toggle>
			<Radio
				id="radio-camera-arm"
				class="d-inline-flex mb-s"
				value="true"
				selected={String(controlOption.params.config.arm)}
				disabled={!controlOption.attr.config.arm}
				size="m"
				on:click={() => (controlOption.params.config.arm = true)}
			>
				{$format('camera_motion_detection_armed', { default: 'Armed' })}
			</Radio>
			<Radio
				id="radio-camera-disarm"
				class="d-inline-flex mb-s"
				value="false"
				selected={String(controlOption.params.config.arm)}
				disabled={!controlOption.attr.config.arm}
				size="m"
				on:click={() => (controlOption.params.config.arm = false)}
			>
				{$format('camera_motion_detection_disarmed', { default: 'Disarmed' })}
			</Radio>
		</div>
	{/if}
	{#if controlOption.attr.config.privacy != undefined}
		<div class="d-flex flex-direction-column">
			<Toggle
				id="toggle-camera-privacy"
				class="mb-s"
				size="m"
				bind:checked={controlOption.attr.config.privacy}
			>
				{$format('local_action_camera_privacy_mode', {
					default: 'Set Privacy Mode property',
				})}
			</Toggle>
			<Radio
				id="radio-camera-privacy-on"
				class="d-inline-flex mb-s"
				value="true"
				selected={String(controlOption.params.config.privacy)}
				disabled={!controlOption.attr.config.privacy}
				size="m"
				on:click={() => (controlOption.params.config.privacy = true)}
			>
				{capFirstChar($format('on_action', { default: 'on' }))}
			</Radio>
			<Radio
				id="radio-camera-privacy-off"
				class="d-inline-flex mb-s"
				value="false"
				selected={String(controlOption.params.config.privacy)}
				disabled={!controlOption.attr.config.privacy}
				size="m"
				on:click={() => (controlOption.params.config.privacy = false)}
			>
				{capFirstChar($format('off_action', { default: 'off' }))}
			</Radio>
		</div>
	{/if}
{/if}
